import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import {
  DEFAULT_ARDOQ_I18NLOCALE,
  type I18nLocale,
  t,
  type WithI18nLocale,
} from '@ardoq/i18n';
import { SurveyHelpText } from '../SurveyHelpText';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';

type SurveyReadOnlyLabelProps = {
  i18nLocale?: I18nLocale;
};

export const SurveyReadOnlyLabel = ({
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: SurveyReadOnlyLabelProps = {}) => (
  <SurveyHelpText
    text={t(i18nLocale, 'surveysUi:readOnlyField', 'Read-only field')}
  />
);

const SurveyReadOnlyFieldDiv = styled(FlexBox)`
  border: 1px solid #d6d9e1;
  overflow-wrap: anywhere;
`;

type SurveyReadOnlyFieldProps = WithI18nLocale;

const SurveyReadOnlyField = ({
  children,
  i18nLocale,
}: PropsWithChildren<SurveyReadOnlyFieldProps>) => (
  <SurveyReadOnlyFieldDiv
    padding="small"
    marginBottom="xsmall"
    borderRadius="r4"
    backgroundColor="surfaceDefaultSubtle"
    width="full"
  >
    <Text color={'textModerate'}>
      {!children
        ? t(i18nLocale, 'surveysUi:noValueSet', 'No value set.')
        : children}
    </Text>
  </SurveyReadOnlyFieldDiv>
);

type SurveyReadOnlyQuestionProps = {
  hideReadOnlyLabel?: boolean;
  i18nLocale?: I18nLocale;
};

export const SurveyReadOnlyQuestion = ({
  children,
  hideReadOnlyLabel,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: PropsWithChildren<SurveyReadOnlyQuestionProps>) => (
  <>
    <SurveyReadOnlyField i18nLocale={i18nLocale}>
      {children}
    </SurveyReadOnlyField>
    {hideReadOnlyLabel ? null : <SurveyReadOnlyLabel i18nLocale={i18nLocale} />}
  </>
);
